import axios from "axios"
import React, { Component } from "react"
import AxiosConfig from "src/utilities/AxiosConfig"
import VehicleInspections from "../../Overview/Inspections/VehicleInspections"
import "./InspectionApprovalDecoupler.css"

interface Props {
    userId: string | number
    vehicleInformationId: string
    vehicleInspectionId: string
    setCompleted?: Function
}

interface State {
    fleetReference: any
    details: any
    inspections: Array<any> | null
    inspectionPics: Array<any>
    comparisonPics: Array<any>
    loadingPreview: boolean
    currentInspection: number
    currentComparison: number
    previewPhoto: string,
    inspectionWarning: boolean
}

class InspectionApprovalDecoupler extends Component<Props, State> {

    opened = false

    state = {
        fleetReference: null,
        details: null,
        inspections: [],
        inspectionPics: [],
        loadingPreview: false,
        comparisonPics: [],
        currentInspection: 0,
        currentComparison: 0,
        previewPhoto: "",
        inspectionWarning: false,
    }

    componentDidMount() {
        this.getFleetReference()
        this.getVehicleInfo()
        this.getVehicleInspections()
    }

    getFleetReference = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/reference", AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ fleetReference: res.data })
                this.getVehicleInfo()
            }).catch(err => {
                //console.log(err)
            })
    }

    getVehicleInfo = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/getVehicleByVehicleInformationId/" + this.props.vehicleInformationId + "", AxiosConfig.configValue())
            .then(res => {
                this.setState({ details: res.data })
                // this.getProfitCenterDescription(res.data)
                // this.getVehicleStatusDescription(res.data)
            }).catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    getVehicleInspections = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/getInspectionsByVehicleId/" + this.props.vehicleInformationId + "", AxiosConfig.configValue())
            .then(res => {
                this.setState({ inspections: res.data.inspections })

                let inspections = res.data.inspections
                //r-18-lint-bk
                //eslint-disable-next-line
                let unreviewed = 0
                for (let i = 0; i < inspections.length; i++) {
                    if (inspections[i].ReviewedBy === "") {
                        //r-18-lint-bk
                        //eslint-disable-next-line
                        unreviewed += 1
                    }
                }
                // if (unreviewed > 0) {
                //     this.preRenderState.inspectionWarning = true
                // } else {
                //     this.preRenderState.inspectionWarning = false
                // }
                this.setState({ inspections: inspections.reverse() })
                // this.preRenderState.inspections = inspections.reverse()
                this.openInspection(inspections[this.state.currentInspection].vehicleInspectionId, this.state.currentInspection)

            }).catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    openComparison = (inspectionId: string, currentComparison: number) => {
        // this.preRenderState.comparisonPics = []
        this.setState({ comparisonPics: [] })
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/getInspectionImages/" + inspectionId, AxiosConfig.configValue())
            .then(res => {
                this.buildComparisonPhotoArray(res.data.inspectionImages)
                // this.preRenderState.currentComparison = currentComparison
                this.setState({ currentComparison: currentComparison })
            }).catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    openInspection = (inspectionId: string, currentInspection: number) => {
        // this.preRenderState.inspectionPics = []
        // this.preRenderState.loadingPreview = true
        this.setState({ inspectionPics: [], loadingPreview: true })
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/getInspectionImages/" + inspectionId, AxiosConfig.configValue())
            .then(res => {
                this.buildInspectionPhotoArray(res.data.inspectionImages)
                // this.preRenderState.currentInspection = currentInspection
                // this.preRenderState.previewPhoto = res.data.inspectionImages[2].imageFullUrl
                this.setState({ currentInspection: currentInspection, previewPhoto: res.data.inspectionImages[2].imageFullUrl })
                if (res.data.inspectionImages.length > 0) {
                    for (let i = 0; i < res.data.inspectionImages.length; i++) {
                        let str = res.data.inspectionImages[i].name.split("_")
                        if (str[1].trim() === "ExteriorDriverFront") {
                            // this.preRenderState.previewPhoto = res.data.inspectionImages[i].imageFullUrl
                            this.setState({ previewPhoto: res.data.inspectionImages[i].imageFullUrl })
                        }
                    }
                }
                // this.preRenderState.loadingPreview = false
                this.setState({ loadingPreview: false })
            }).catch(err => {
                // this.preRenderState.previewPhoto = "none"
                // this.preRenderState.loadingPreview = false
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    buildInspectionPhotoArray = (pics: Array<any>) => {
        let picsArray: Array<any> = []
        for (let i = 0; i < pics.length; i++) {
            let temp: any = {}
            temp.img = pics[i].imageFullUrl
            let splitter: Array<String> = pics[i].name.split("_")
            temp.name = splitter[1]
            picsArray.push(temp)
        }
        // this.preRenderState.inspectionPics = picsArray
        this.setState({ inspectionPics: picsArray })
    }

    buildComparisonPhotoArray = (pics: Array<any>) => {
        let picsArray: Array<any> = []
        for (let i = 0; i < pics.length; i++) {
            let temp: any = {}
            temp.img = pics[i].imageFullUrl
            let splitter: Array<String> = pics[i].name.split("_")
            temp.name = splitter[1]
            picsArray.push(temp)
        }
        // this.preRenderState.comparisonPics = picsArray
        this.setState({ comparisonPics: picsArray })
    }

    setInspectionWarning = (warning: boolean) => {
        // this.preRenderState.inspectionWarning = warning
        this.setState({ inspectionWarning: warning })
    }


    render() {

        const state = this.state

        return (
            <div className="InspectionApprovalDecoupler">

                <VehicleInspections
                    details={state.details}
                    inspections={state.inspections}
                    inspectionPics={state.inspectionPics}
                    comparisonPics={state.comparisonPics}
                    currentInspection={state.currentInspection}
                    currentComparison={state.currentComparison}
                    getVehicleInfo={this.getVehicleInspections}
                    setWarning={this.setInspectionWarning}
                    openInspection={this.openInspection}
                    openComparison={this.openComparison}
                    sideMenuOpen={false}
                    refreshAll={() => null}
                    showLinkPopover={false}
                />

                {/* {!ready && <div className="InspectionApprovalDecouplerLoading">
                    <span className="material-icons">build</span>
                    <Loader title="Loading Maintenance record" />
                </div>} */}
            </div>
        )
    }
}

export default InspectionApprovalDecoupler;